import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Marketing et Management",
  icon: "💼",
  tagline: "Développez vos compétences en stratégie marketing et management d'équipes",
  duree: "3 à 5 ans",
  diplome: "Licence/Master",
  mode: "Présentiel",
  nombreDebouches: "14",
  description: "La filière Marketing et Management forme des professionnels capables de concevoir et mettre en œuvre des stratégies marketing efficaces, tout en maîtrisant les compétences managériales essentielles. Notre programme combine théorie et pratique pour préparer les étudiants aux défis du marché moderne.",
  objectifs: [
    "Maîtriser les fondamentaux du marketing et de la communication",
    "Développer des compétences en management et leadership",
    "Comprendre le comportement du consommateur",
    "Acquérir une expertise en marketing digital",
    "Maîtriser les techniques de vente et de négociation"
  ],
  programme: [
    {
      titre: "Licence 1 & 2",
      matieres: [
        "Fondamentaux du marketing",
        "Comportement du consommateur",
        "Communication d'entreprise",
        "Gestion commerciale",
        "Études de marché",
        "Introduction au management"
      ]
    },
    {
      titre: "Licence 3 & Master",
      matieres: [
        "Marketing stratégique",
        "Marketing digital et e-commerce",
        "Management des équipes",
        "Brand management",
        "Stratégie d'entreprise",
        "Innovation et créativité"
      ]
    }
  ],
  debouches: [
    { titre: "Chef de produit", description: "Gestion et développement de gammes de produits" },
    { titre: "Directeur marketing", description: "Pilotage de la stratégie marketing" },
    { titre: "Manager commercial", description: "Gestion d'équipes commerciales" },
    { titre: "Consultant en stratégie", description: "Conseil stratégique aux entreprises" },
    { titre: "Community manager", description: "Gestion de la présence digitale" },
    { titre: "Responsable communication", description: "Pilotage de la communication d'entreprise" }
  ],
  competences: [
    "Maîtrise des stratégies marketing modernes",
    "Compétences en management et leadership",
    "Expertise en marketing digital et réseaux sociaux",
    "Capacité d'analyse des marchés et de la concurrence",
    "Compétences en communication et négociation",
    "Créativité et innovation"
  ]
};

export default function MarketingManagement() {
  return <FiliereTemplate filiere={filiereData} />;
}